import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Price } from '../price.model';
import { PriceActions, PriceActionTypes } from '../actions/price.actions';

export interface State extends EntityState<Price> {
  // additional entities state properties
  Loaded: boolean;
  Loading: boolean;
  
}

export const adapter: EntityAdapter<Price> = createEntityAdapter<Price>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  Loaded: false,
  Loading: false
});

export function reducer(
  state = initialState,
  action: PriceActions
): State {
  switch (action.type) {
    case PriceActionTypes.AddPrice: {
      return adapter.addOne(action.payload.price, state);
    }

    case PriceActionTypes.UpsertPrice: {
      return adapter.upsertOne(action.payload.price, state);
    }

    case PriceActionTypes.AddPrices: {
      return adapter.addMany(action.payload.prices, state);
    }

    case PriceActionTypes.UpsertPrices: {
      return {...state, Loaded: true, Loading: false , entities: action.payload};
    }

    case PriceActionTypes.UpdatePrice: {
      return adapter.updateOne(action.payload.price, state);
    }

    case PriceActionTypes.UpdatePrices: {
      return adapter.updateMany(action.payload.prices, state);
    }

    case PriceActionTypes.DeletePrice: {
      return adapter.removeOne(action.payload.id, state);
    }

    case PriceActionTypes.DeletePrices: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case PriceActionTypes.LoadPrices: {
      return {...state, Loaded: false, Loading: true};
    }

    case PriceActionTypes.ClearPrices: {
      return adapter.removeAll(state);
    }

    case PriceActionTypes.GetPricesFails: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
